import React from 'react';
import PropTypes from 'prop-types';
// import { useSelector } from "react-redux";
import classes from './footer.module.css';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { AppStore, LogoWhite, mobilePhone, PlayStore } from '../../constant/imagePath';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Footer = ({
  containerClass = '',
  bgColor = 'var(--page-bg-color)',
  showDownload = true,
  safeNavigate
}) => {
  const { t } = useTranslation('webCommon');
  // const cmsData = useSelector((state) => state?.commonReducer?.cms?.footer);
  const { isLogin } = useSelector((state) => state?.authReducer);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <div className={showDownload ? classes.footer : ''} style={{ backgroundColor: bgColor }}>
      {showDownload && (
        <div className={classes.footerOne}>
          <Container className={[classes.containerClass, containerClass].join(' ')}>
            <Row className={classes.firstRow}>
              <Col xs={0} md={6}>
                <img src={mobilePhone} alt="mobile" draggable={false} />
              </Col>
              <Col xs={12} md={true}>
                <div className={classes.textWithImages}>
                  <h6>{t('webFooter.downloadNow')}</h6>
                  <p>{t('webFooter.downloadNowText')}</p>
                  <div>
                    <div className={classes.imgDiv}>
                      <img src={AppStore} alt="" draggable={false} />
                    </div>
                    <div className={classes.imgDiv}>
                      <img src={PlayStore} alt="" draggable={false} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <div className={classes.footerTwo}>
        <Container className={classes.container}>
          <Row className={classes.row}>
            <Col md={3}>
              <img src={LogoWhite} alt="" draggable={false} />
            </Col>
            <Col md={6}>
              <div className={classes.topLinks}>
                <div className={classes.links}>
                  <Link
                    to={'/contact-us'}
                    onClick={(e) => {
                      e.preventDefault();
                      if (safeNavigate) {
                        safeNavigate('/contact-us');
                        return;
                      }
                      window.location.href = '/contact-us';
                    }}>
                    {t('webFooter.contactUs')}
                  </Link>
                  <Link
                    to={'/blog'}
                    onClick={(e) => {
                      e.preventDefault();
                      if (safeNavigate) {
                        safeNavigate('/blog');
                        return;
                      }
                      window.location.href = '/blog';
                    }}>
                    {t('webFooter.blog')}
                  </Link>
                  <Link
                    to={'/advertise-with-us'}
                    onClick={(e) => {
                      e.preventDefault();
                      if (safeNavigate) {
                        safeNavigate('/advertise-with-us');
                        return;
                      }
                      window.location.href = '/advertise-with-us';
                    }}>
                    {t('webFooter.advertiseWithUs')}
                  </Link>
                </div>
              </div>
            </Col>
            <Col md={3} className={classes.flexEnd}>
              {!isLogin && (
                <Button
                  variant="transparent"
                  className={classes.agentLoginBtn}
                  borderRadius={'3px'}
                  onClick={() => navigate('/agent-company-login')}>
                  {t('webFooter.login')}
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <div className={classes.footerThree}>
        <Container className={classes.container}>
          <div className={classes.copyRightText}>
            <p>
              ©{currentYear} Turegu. {t('webFooter.copyRightText')}.
            </p>
          </div>
          <div className={classes.bottomLinks}>
            <Link
              to={'/terms-and-conditions'}
              onClick={(e) => {
                e.preventDefault();
                if (safeNavigate) {
                  safeNavigate('/terms-and-conditions');
                  return;
                }
                window.location.href = '/terms-and-conditions';
              }}>
              {t('webFooter.termsAndConditions')}
            </Link>
            <Link
              to={'/privacy-policy'}
              onClick={(e) => {
                e.preventDefault();
                if (safeNavigate) {
                  safeNavigate('/privacy-policy');
                  return;
                }
                window.location.href = '/privacy-policy';
              }}>
              {t('webFooter.privacyPolicy')}
            </Link>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Footer;

Footer.propTypes = {
  containerClass: PropTypes.string
};
